import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import CurrencyConverterPage from "./Pages/CurrencyConverter";
import CurrencyConverterPage2 from "./Pages/CurrencyConverter/index2";

function App() {
  const router = createBrowserRouter([
    {
      path: "/2",
      element: <CurrencyConverterPage />,
    },
    {
      path: "/",
      element: <CurrencyConverterPage2 />,
    },
    // {
    //   path: "CurrencyConverterPage2",
    //   element: <CurrencyConverterPage2 />
    // }
  ]);

  return (
    <RouterProvider router={router} />
    // <div className="App">
    //   <CurrencyConverterPage />
    // </div>
  );
}

export default App;
